import { EnumOwnerType, Owner } from "gql/generated";

export const getOrderUrl = (
  orderId: string,
  loggedInAs: Owner | null,
  storefrontId?: string | null,
) => {
  const effectiveStorefrontId =
    loggedInAs?.type === EnumOwnerType.Storefront
      ? loggedInAs.entityId
      : storefrontId;

  if (effectiveStorefrontId) {
    return `/app/storefront/${effectiveStorefrontId}/order/${orderId}`;
  }

  return `/order/${orderId}`;
};
